import {
  Component,
  ComponentFactoryResolver,
  Inject,
  Injector,
  OnInit,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import { POPUP_INJECT } from "../../../../../services/popup/popup-ref";
import { Subject } from "rxjs";
import { PopupComponent } from "../../../../../services/popup/popup-component";

export interface PdfViewerLoaderPopupData {
  name: string;
  src: string;
}

@Component({
  selector: "pms-pdf-viewer-loader",
  templateUrl: "pdf-viewer-loader.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class PdfViewerLoaderComponent implements OnInit, PopupComponent {
  @ViewChild("pdfViewerContainer", { read: ViewContainerRef })
  pdfViewerContainer!: ViewContainerRef;

  loading: boolean = false;
  error: boolean = false;

  title$?: Subject<string> | undefined;

  constructor(
    private injector: Injector,
    private componentFactoryResolver: ComponentFactoryResolver,
    @Inject(POPUP_INJECT.DATA) private data: PdfViewerLoaderPopupData
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.error = false;
  }

  isTitleVisible(): boolean {
    return false;
  }
  getTitle(): string {
    return this.data.name;
  }

  getSubtitle(): string {
    return "";
  }

  async ngAfterViewInit(): Promise<void> {
    await this.load();
  }

  private async load(): Promise<void> {
    try {
      const { PdfViewerImplComponent } =
        await import("../pdf-viewer-impl/pdf-viewer-impl.component");

      const pdfViewerImplComponentComponentFactory =
        this.componentFactoryResolver.resolveComponentFactory(
          PdfViewerImplComponent
        );

      const pdfViewerComponent = this.pdfViewerContainer.createComponent(
        pdfViewerImplComponentComponentFactory
      );

      pdfViewerComponent.instance.src = this.data.src;
      pdfViewerComponent.instance.name = this.data.name;
    } catch (ex) {
      console.error(ex);
      this.error = false;
    } finally {
      this.loading = false;
    }
  }
}
